import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage, useAuth } from '../App';
import { useTheme } from '../theme';
import { apiUrl } from '../api';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [msg, setMsg] = useState('');
  const { language } = useLanguage();
  const { setToken } = useAuth();
  const navigate = useNavigate();
  const { tokens } = useTheme();
  const t = {
    en: {
      login: 'Login',
      username: 'Username',
      password: 'Password',
      success: 'Login successful!',
      fail: 'Login failed',
      button: 'Login',
    },
    ro: {
      login: 'Autentificare',
      username: 'Utilizator',
      password: 'Parolă',
      success: 'Autentificare reușită!',
      fail: 'Autentificare eșuată',
      button: 'Autentificare',
    }
  };
  const tr = t[language];

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await fetch(apiUrl('/api/auth/login'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password })
    });
    const data = await res.json();
    if (data.token) {
      try { localStorage.setItem('token', data.token); } catch {}
      setToken(data.token);
      setMsg(tr.success);
      setTimeout(() => navigate('/dashboard'), 300);
    } else {
      setMsg(data.error || tr.fail);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: 420, margin: '32px auto', background: tokens.surface, borderRadius: 16, boxShadow: `0 4px 24px ${tokens.shadow}`, padding: 32, display: 'flex', flexDirection: 'column', gap: 16, color: tokens.text }}>
      <h2 style={{ fontSize: 28, fontWeight: 700, marginBottom: 16, textAlign: 'center' }}>{tr.login}</h2>
      <input placeholder={tr.username} value={username} onChange={e => setUsername(e.target.value)} required style={getInputStyle(tokens)} />
      <input type="password" placeholder={tr.password} value={password} onChange={e => setPassword(e.target.value)} required style={getInputStyle(tokens)} />
      <button type="submit" style={{ background: `linear-gradient(90deg, ${tokens.accent} 0%, ${tokens.accent2} 100%)`, color: tokens.inverse, border: 'none', borderRadius: 8, padding: '12px 0', fontWeight: 700, fontSize: 18, cursor: 'pointer', marginTop: 8, boxShadow: `0 2px 8px ${tokens.shadowSoft}`, transition: 'background 0.2s' }}>{tr.button}</button>
      {msg && <p style={{ color: msg.includes(tr.fail) ? '#ff5252' : tokens.accent, textAlign: 'center', marginTop: 8 }}>{msg}</p>}
    </form>
  );
}

function getInputStyle(tokens) {
  return {
    background: tokens.panel,
    color: tokens.text,
    border: `1px solid ${tokens.mutedBorder}`,
    borderRadius: 8,
    padding: '10px 12px',
    fontSize: 16,
    marginBottom: 0,
  };
}
